<!-- ChildComponent.vue -->
<template>
  <div>
    <h2>{{ childProp }} this is from child</h2>
  </div>
</template>

<script>
export default {
  props: {
    childProp: String, // Define the expected type of the prop
  },
};
</script>
